<template>
  <fragment>
    <router-view></router-view>
  </fragment>
</template>

<script>
export default {
  name: "Reports"
};
</script>

<style scoped>
</style>
